import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import { User } from '../auth';
import { BidChance } from '../bid-chances';
import { BidPackage } from '../bid-packages';
import * as actions from './actions';
import { Vendor } from '../vendors';

export type BiddersAction = ActionType<typeof actions>;

export interface BiddersState {
  bidders: {
    data: Bidder[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  bidder: {
    data: Bidder | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export interface BidderParams {
  enterpriseId: string;
  projectId: string;
  bidPackageId?: string;
  bidderId?: string;
  bidder?: Bidder;
  vendorIdList?: number[];
  createContractDto?: any;
  lastBidProposalId?: number;
  bidderIdList?: number[];
  tempBidders?: any[];
}

export enum BidderStatus {
  NOT_INVITED = '0',
  INVITED = '1',
  ACCEPTED = '2',
  DECLINED = '3',
  SUBMITTED = '4',
  AWARDED = '5',
  NOT_AWARDED = '6',
  RECONFIRM = '7',
}

export const bidderStatusKorean = {
  '0': '미발송',
  '1': '발송완료',
  '2': '참가 수락',
  '3': '참가 거절',
  '4': '제출완료',
  '5': '낙찰',
  '6': '미선정',
  '7': '재요청',
} as const;

export interface Bidder {
  id: number;
  enterpriseId: string;
  projectId: string;
  bidPackageId: string;
  status: BidderStatus;
  reconfirmReason: string;
  vendor: Vendor;
  users: User[];
  bidPackage?: BidPackage;
  bidChance?: BidChance;
  recentAmount?: number;
  tempBidder?: any;
  isBriefingAttend: boolean;
}
